module.exports = __webpack_public_path__ + "static/media/Monza.5f23f58b.png";